import { CIAN_MORTGAGE_URL_CONFIG_KEY, OFFERS_BASE_QUERY_URL_CONFIG_KEY } from '../../../constants/config';
import { EPromoType } from '../../../types/promos/promoType';
import { useApplicationContext } from '../../../utils/applicationContext';

import cianMortgageTextSvg from '../assets/cianMortgageText.svg';
import standardTextSvg from '../assets/standardText.svg';

interface IResult {
  url: string;
  textImage: string;
}

export const useLinkButtonData = (promoType: EPromoType, newbuildingIds: number[]): IResult => {
  const { config } = useApplicationContext();

  if (promoType === EPromoType.CianMortgage) {
    return {
      textImage: cianMortgageTextSvg,
      url: config.getStrict<string>(CIAN_MORTGAGE_URL_CONFIG_KEY),
    };
  }

  const baseQueryUrl = config.getStrict<string>(OFFERS_BASE_QUERY_URL_CONFIG_KEY);

  const newobjectParams = newbuildingIds.map((id, index) => `newobject[${index}]=${id}`).join('&');

  return {
    textImage: standardTextSvg,
    url: `${baseQueryUrl}&${newobjectParams}`,
  };
};
